<template lang="html">
  <div class="">
    <si-container>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <v-layout align-center>
              <v-avatar
                class="profile"
                color=""
                size="64"
                tile
              >
                <v-img src="https://pngimg.com/uploads/microsoft/microsoft_PNG9.png" />
              </v-avatar>
              <v-flex>
                Microsoft
                <div class="caption">
                  {{ msStatus.tenantName }}
                </div>
              </v-flex>
              <v-flex
                v-if="msStatus.connected && !msStatusLoading"
                shrink
              >
                <v-btn 
                  text
                  href="https://outlook.office.com/bookings/settings/services"
                  target="_blank"
                  class="mr-2"
                  depressed
                >
                  Microsoft Bookings 
                </v-btn>
              </v-flex>
              <v-flex
                v-if="!msStatus.connected && !msStatusLoading"
                shrink
              >
                <v-btn 
                  color="info" 
                  depressed 
                  :loading="msAuthLoading" 
                  @click="connectMicrosoft"
                >
                  Connect Microsoft
                </v-btn>
              </v-flex>
              <v-flex
                v-if="msStatus.connected && !msStatusLoading"
                shrink
              >
                <SiDeleteButton
                  title="Disconnect Microsoft"
                  message="Are you absolutely sure? Very bad things will happen"
                  @delete="disconnectMicrosoft"
                >
                  <template #activator="{ attrs, on }">
                    <v-btn 
                      v-bind="attrs"
                      color="error"
                      depressed 
                      :loading="msAuthLoading" 
                      v-on="on" 
                    >
                      Disconnect
                    </v-btn>
                  </template>
                </SiDeleteButton>
              </v-flex>
            </v-layout>
          </v-card-title>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <v-layout>
              <v-flex>Services</v-flex>
              <v-flex
                v-if="msStatus.connected && !msStatusLoading"
                shrink
              >
                <v-btn 
                  color="primary" 
                  depressed 
                  :loading="syncing" 
                  @click="syncServices"
                >
                  Sync
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card-title>
          <v-divider />
          <v-list>
            <v-list-item
              v-for="service in services"
              :key="service.id"
            >
              <v-list-item-content>
                <v-list-item-title>{{ service.name }}</v-list-item-title>
                <v-list-item-subtitle>{{ _$(service.price) }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-card-text>
            
            <v-flex pa-0 xs12 md6>
              <SiInputPercent
              v-model="licensePercent"
              outlined
              hide-detailsx
              cents
              required
              label="License price"
              :error="licensePercent < ''"
              @change="save"
            />
            </v-flex>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12>
        <v-card>
          <v-card-title>
            <v-layout ma-0>
              <v-flex pa-0>
                Consulting page
              </v-flex>
              <v-btn
                v-if="consultingPageDirty"
                depressed
                color="primary"
                @click="saveconsultingPage"
              >
                Save
              </v-btn>
            </v-layout>
          </v-card-title>
          <SiQuill
            v-model="consultingPage"
            rounded-corners-bottom
            hide-details
            @change="consultingPageDirty = true"
          />
        </v-card>
      </v-flex>
    </si-container>
  </div>
</template>

<script>
import { rtdb, db } from "@/plugins/firebase";
import helpers from "@/mixins/helpers";
import binder from "@/mixins/binder";
import axios from "@/app-console/plugins/axios";

export default {
  mixins: [helpers, binder],
  data() {
    return {
      services: [],
      msStatus: { connected: null },
      msStatusLoading: true,
      msAuthWindow: null,
      msAuthLoading: false,
      syncing: false,
      consultingPage: "",
      consultingPageDirty: false,
      licensePercent: 0,
    };
  },
  watch: {
    consultingPage(v, ov) {
      if (!ov && v) {
        this.$nextTick(() => (this.consultingPageDirty = false));
      }
    },
    msStatus(v) {
      if (v.connected && this.msAuthLoading) this.msAuthLoading = false
      if (v.connected && this.msAuthWindow) {
        this.msAuthWindow.close();
      }
    },
  },
  beforeMount() {
    const callback = (data) => {
      this.services = this._sortObject(data.services)
      this.licensePercent = data.licensePercent || 0
    };
    this.$bindDb("services", "services/consulting", { callback });
    this.$bindRtdb("consultingPage", "site/pages/consulting/html", {
      loader: true,
      defaultData: "",
    });
    this.$bindDb("msStatus", "microsoft/status", {
      loader: "msStatusLoading",
    });
    this.$store.commit('set_appBarTitle', { title: 'Consulting', icon: 'event' })

  },
  mounted() {},
  methods: {
    async syncServices() {
      this.syncing = true;
      await axios.post(`${process.env.VUE_APP_API_URL}/microsoft/run-sync`);
      this.syncing = false;
    },
    saveconsultingPage() {
      rtdb.ref("site/pages/consulting").set({
        updated: new Date().toISOString(),
        html: this.consultingPage,
      });
      this.consultingPageDirty = false;
    },
    save () {
      db.doc('services/consulting').update({
        licensePercent: this.licensePercent,
      })
    },
    async connectMicrosoft() {
      const { data } = await axios.get(
        `${process.env.VUE_APP_API_URL}/microsoft/auth`
      );
      if (data) {
        this.msAuthLoading = true
        this.msAuthWindow = window.open(data, "_blank");
      }
    },
    async disconnectMicrosoft() {
      await axios.post(
        `${process.env.VUE_APP_API_URL}/microsoft/auth/disconnect`
      );
    }
  },
};
</script>

<style lang="css" scoped>
</style>
